const getCurrentTime = () => {
    const d = new Date()
    return `${`${d.getHours()}`.padStart(2, "0")}:${`${d.getMinutes()}`.padStart(2, "0")}:${`${d.getSeconds()}`.padStart(2, "0")}.${`${d.getMilliseconds()}`.padStart(3, "0")}`
}

export const useLogger = (
    subject: string | undefined,
    callback?: (msg: string) => void
) => {
    const verbose = (msg: unknown, pushNotification?: boolean) => {
        console.log(
            `%c${getCurrentTime()}${subject ? ` - ${subject}` : null}`,
            "color:#606060;font-weight:400;",
            msg
        )
        if (callback && pushNotification && typeof msg === "string")
            callback(msg)
    }

    const log = (msg: unknown, pushNotification?: boolean) => {
        console.log(
            `%c${getCurrentTime()}${subject ? ` - ${subject}` : null}`,
            "color:#208050;font-weight:400;",
            msg
        )
        if (callback && pushNotification && typeof msg === "string")
            callback(msg)
    }

    const warn = (msg: unknown, pushNotification?: boolean) => {
        console.warn(
            `%c${getCurrentTime()}${subject ? ` - ${subject}` : null}`,
            "color:#ff8050;font-weight:700;",
            msg
        )
        console.trace()
        if (callback && pushNotification && typeof msg === "string")
            callback(msg)
    }

    const error = (msg: unknown, pushNotification?: boolean) => {
        console.error(
            `%c${getCurrentTime()}${subject ? ` - ${subject}` : null}`,
            "color:#ff0000;font-weight:800;",
            msg
        )
        console.trace()
        if (callback && pushNotification && typeof msg === "string")
            callback(msg)
    }

    const socketSend = (type: string, msg: unknown) => {
        console.debug(
            `  %c${getCurrentTime()} - Websocket %cSEND >> %c${type}`,
            "color:#606060;font-weight:400;",
            "color:#208050;font-weight:700;",
            "color:#606060;font-weight:500;",
            msg
        )
    }

    const socketReceive = (type: string, msg: unknown) => {
        console.debug(
            `  %c${getCurrentTime()} - Websocket %cRECEIVE << %c${type}`,
            "color:#606060;font-weight:400;",
            "color:#ff0000;font-weight:700;",
            "color:#606060;font-weight:500;",
            msg
        )
    }

    return {
        log,
        verbose,
        warn,
        error,
        socketSend,
        socketReceive: socketReceive,
    }
}
